export const GET_HOME_GENRES = 'HOME_GENRES';
export const GET_GENRES_WITH_COUNT = 'GET_GENRES_WITH_COUNT';
export const GET_GENRES_SONG = 'GET_GENRES_SONG';
export const GET_EDIT_SONG_GENRES = 'GET_EDIT_SONG_GENRES';
export const GET_CURATED_GENRES = 'GET_CURATED_GENRES';
export const GET_GENRES_DOWNLOAD_REPORT = 'GET_GENRES_DOWNLOAD_REPORT';
export const GET_DOWNLOAD_REPORT_BY_GENRES_SONG = 'GET_DOWNLOAD_REPORT_BY_GENRES_SONG';